import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c0_custom_block.scss";
import { insertHtml } from "../../utils/dom";


interface C0CustomBlockData {
    title?: string;
    content?: string;
    html?: React.ReactElement<any>;
}

class C0CustomBlock extends TemplateComponent<C0CustomBlockData> {

    componentRender(data: C0CustomBlockData): React.ReactElement<any> {
        return (
            <div className="c0-custom-block">
                {data.title && <h3 className="component-title">{data.title}</h3>}
                {data.content ?
                    <div className="content editor-html" {...insertHtml(data.content)}/>
                    :
                    <div className="content editor-html">{data.html}</div>
                }
            </div>

        )
    }
}

export default C0CustomBlock;